import {createSelector} from 'reselect';

import type {NutshellState} from '../../../../store';

export const getMcfxCompaniesState = (state: NutshellState) => state.mcfxCompanies;

export const getMcfxCompaniesListState = createSelector(
    [getMcfxCompaniesState],
    (mcfxCompaniesState) => mcfxCompaniesState.mcfxCompaniesList
);

export const getIsFilterDrawerOpen = createSelector(
    [getMcfxCompaniesState],
    (mcfxCompaniesState) => {
        return mcfxCompaniesState.isFilterDrawerOpen;
    }
);

export const getMcfxCompaniesListItems = createSelector(
    [getMcfxCompaniesListState],
    (mcfxCompaniesListState) => {
        return mcfxCompaniesListState.listItems;
    }
);

export const getMcfxCompaniesListIsLoading = createSelector(
    [getMcfxCompaniesListState],
    (mcfxCompaniesListState) => {
        return mcfxCompaniesListState.isLoading;
    }
);
export const getMcfxCompaniesListIsFirstLoad = createSelector(
    [getMcfxCompaniesListState],
    (mcfxCompaniesListState) => {
        return mcfxCompaniesListState.isFirstLoad;
    }
);
export const getMcfxCompaniesListHasError = createSelector(
    [getMcfxCompaniesListState],
    (mcfxCompaniesListState) => {
        return Boolean(mcfxCompaniesListState.errorMessage);
    }
);

export const getMcfxCompaniesListCount = createSelector(
    [getMcfxCompaniesListState],
    (mcfxCompaniesListState) => {
        return mcfxCompaniesListState.meta.count ? mcfxCompaniesListState.meta.count : 0;
    }
);

export const getMcfxCompaniesSchema = createSelector(
    [getMcfxCompaniesState],
    (mcfxCompaniesState) => mcfxCompaniesState.mcfxCompaniesSchema
);
